import { TasksTypes } from '@entities/task';
import { Task } from 'entities/task/model/types/tasks';

import { Filters } from '../types/taskHeader';

const colorMapping = {
    '#9DA1AC': 'gray',
    '#22B7D7': 'mint',
    '#ECD71F': 'yellow',
    '#F16767': 'red',
    '#FC67FF': 'pink',
    '#CE66F1': 'majenta',
};

const isFilterTypeTasks = (task: Task, filters: Filters): boolean =>
    filters.type.some((typeItem) => {
        if (typeItem === TasksTypes.CUSTOM && task.type === 'custom') {
            return true;
        }
        if (typeItem === TasksTypes.SUPPLY_REQUEST && task.category === 'supply-request') {
            return true;
        }
        const isPayment = task.category === 'payment-plan' || task.category === 'payment-request';
        if (typeItem === TasksTypes.PAYMENT && isPayment) {
            return true;
        }
        const isGantt = task.category === 'gantt-labor' || task.category === 'gantt-mhd';
        if (typeItem === TasksTypes.GANTT && isGantt) {
            return true;
        }
        return false;
    });

export const filterTasks = (tasks: Task[], filters: Filters): string[] =>
    tasks
        .filter(
            (task) =>
                task.title.toLowerCase().includes(filters.search.toLowerCase()) ||
                task?.context?.description?.toLowerCase().includes(filters.search.toLowerCase())
        )
        .filter((task) => isFilterTypeTasks(task, filters))
        .filter((task) => (filters.projects ? task.project_id === +filters.projects : true))
        .filter((task) => (filters.estimate ? task.estimate_id === +filters.estimate : true))
        .filter((task) =>
            filters.colors.length
                ? // @ts-ignore
                  filters.colors.includes(colorMapping[task.context.color])
                : true
        )
        .filter((task) =>
            filters.tags.length
                ? task?.context?.tags?.some((tag) => filters.tags.includes(tag))
                : true
        )
        .filter((task) =>
            filters.executors.length
                ? filters.executors.includes(task?.involved?.executor_id)
                : true
        )
        .map((task) => task.uid);
